<div class="login-viewport">
  <div class="login-theme-toggle">
    <mat-icon>{{ darkMode() ? 'dark_mode' : 'light_mode' }}</mat-icon>
    <span class="toggle-switch-wrap">
      <p-inputSwitch
        styleClass="theme-switch"
        [ngModel]="darkMode()"
        (ngModelChange)="setDarkMode($event)"
        ariaLabel="Attiva tema scuro"
      ></p-inputSwitch>
    </span>
  </div>

  <mat-card class="login-card">
    <!-- Logo -->
    <div class="logo-container">
      <img
        [src]="logoPath()"
        alt="Logo"
        class="logo"
      />
    </div>
    <div class="demo-info" *ngIf="demoDaysLeft() !== null">
      <ng-container *ngIf="demoDaysLeft()! > 0; else expiredOrToday">
        Il periodo di prova della piattaforma scade tra
        {{ demoDaysLeft() }} giorni
      </ng-container>

      <ng-template #expiredOrToday>
        Il periodo di prova della piattaforma è terminato.
      </ng-template>
    </div>
    <h1>Accedi</h1>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <!-- EMAIL -->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email" spellcheck="false"  [readonly]="otpStep"/>
        <mat-icon matPrefix fontSet="material-icons-outlined">email</mat-icon>
        <mat-error *ngIf="f.email.touched && f.email.errors?.['required']">
          Inserisci l'email.
        </mat-error>
        <mat-error *ngIf="f.email.touched && f.email.errors?.['email']">
          Email non valida.
        </mat-error>
      </mat-form-field>

      <!-- PASSWORD -->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
          autocomplete="current-password" />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword = !hidePassword">

          <mat-icon>
            {{ hidePassword ? 'visibility' : 'visibility_off' }}
          </mat-icon>
        </button>
        <mat-icon matPrefix fontSet="material-icons-outlined">lock</mat-icon>
        <mat-error *ngIf="f.password.touched && f.password.errors?.['required']">
          Inserisci la password.
        </mat-error>
        <mat-error *ngIf="f.password.touched && f.password.errors?.['minlength']">
          Minimo
          {{ f.password.errors?.['minlength']?.requiredLength }} caratteri.
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="otpStep" appearance="outline" class="w-100">
        <mat-label>Codice OTP</mat-label>
        <input
          matInput
          formControlName="otp"
          autocomplete="one-time-code"
          maxlength="6"
          [errorStateMatcher]="otpErrorStateMatcher"
        />
        <mat-icon matPrefix fontSet="material-icons-outlined">pin</mat-icon>

        <mat-error *ngIf="f.otp.touched && f.otp.errors?.['required']">
          Inserisci il codice OTP.
        </mat-error>
      </mat-form-field>
      <a  *ngIf="!otpStep" class="forgot-link" routerLink="/reset-pwd">Password dimenticata?</a>


      <a
        *ngIf="otpStep"
        class="forgot-link"
        href="javascript:void(0)"
        (click)="changeAccount()">
        Usa un altro account
      </a>

      <!-- OPTIONS -->
      <div class="options">
        <mat-checkbox formControlName="remember">Resta collegato</mat-checkbox>
      </div>

      <!-- SUBMIT -->
      <button esse-button variant="primary" class="w-100 btn-submit" type="submit" [disabled]="form.invalid || loading">
        <ng-container *ngIf="!loading; else loadingTpl"> {{ otpStep ? 'Verifica codice' : 'Entra' }}</ng-container>
      </button>

      <ng-template #loadingTpl>
        <span class="btn-loading">
          <mat-progress-spinner diameter="18" mode="indeterminate">
          </mat-progress-spinner>
          <span>{{ otpStep ? 'Verifica…' : 'Accesso…' }}</span>
        </span>
      </ng-template>

      <!-- ERROR -->
      <div class="login-feedback" *ngIf="error">
        <mat-icon fontSet="material-icons-outlined">info</mat-icon>

        <div>
          <strong>Accesso non riuscito</strong>
          <span>{{ error }}</span>
        </div>
      </div>
    </form>
  </mat-card>
</div>
